import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import BoardsShareLoopBasicsComponent from 'webapp/components/boards/share/loop-basics';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

import type BoardLoop from 'webapp/models-custom/board-loop';

export default class BoardLoopsPopupEditComponent extends PopupInnerModalComponent<PopupData.BoardLoop.Edit> {
	@service('infolayer') declare infolayerService: Service.Infolayer;
	@service('request') declare requestService: Service.Request;
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/board-loops')
	declare mmBoardLoopsService: Service.ModelManager.BoardLoops;

	get model(): BoardLoop {
		return this.popupData.model;
	}

	@action
	save(): void {
		if (this.submitInProgress) {
			return;
		}

		const model = this.model;

		if (!model) {
			return;
		}

		if (!model.boardIds.length) {
			this.infolayerService.error('You must select at least one dashboard to create a loop!');
			return;
		}

		const isCreate = model.isNew,
			origin = this.popupData.trackingOrigin;

		this.submitInProgress = true;

		model
			.save()
			.then(() => {
				this.analyticsService.event(
					isCreate ? TrackingEvent.LOOP_CREATED : TrackingEvent.LOOP_EDITED,
					{ origin },
				);
				this.infolayerService.ok('Looped dashboard saved!');

				if (isCreate) {
					if (this.navigationService.activatedRoute.startsWith('boards.index')) {
						this.navigationService.transitionToRoute('boards.loops');
					} else if (this.navigationService.activatedRoute.startsWith('designer')) {
						if (model.canCurrentUserEditSomeBoard) {
							this.mmBoardLoopsService.openInDesigner(model);
						}
					}
				}

				this.close();
			})
			.finally(() => {
				this.submitInProgress = false;
			})
			.catch(this.requestService.showAllValidationErrors.bind(this.requestService));
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Loop" @size="lg" />
			{{#if this.model.isNew}}
				Create looped dashboards
			{{else}}
				Edit looped dashboards
			{{/if}}
		</div>

		<div class="content">

			<BoardsShareLoopBasicsComponent
				@model={{this.model}}
				@onContentChange={{this.reposition}}
			/>

			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Cancel"
						@theme="grey-empty"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
					<SubmitButtonComponent
						@text="Save"
						@extraClass="save"
						@onTrigger={{this.save}}
						@submitInProgress={{this.submitInProgress}}
					/>
				</div>
			</div>

		</div>
	</template>
}
